import React from 'react';

interface EventTableHeaderProps {
    headers: string[]
    sort: (header: string) => void
}

export const EventTableHeader: React.FC<EventTableHeaderProps> = ({ headers, sort }) => {

  const styles = 'bg-blue-100 text-left text-brand-dark_blue px-8 py-4 h-12 cursor-pointer hover:text-brand-blue truncate'
  
  return (
        <tr className='flex flex-col flex-no wrap md:table-row rounded-l-lg md:rounded-none mb-2 md:mb-0'>
            {headers.map(header => 
              <th 
                key={header} 
                className={styles} 
                onClick={() => sort(header)}>
                {header.toUpperCase()}
              </th>)}
        </tr>
  );
}

export default EventTableHeader;
